import { styled, Dialog, DialogTitle, Typography, TableContainer, TableHead, TableRow, TableCell } from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    maxWidth: '900px', // Adjusted for table width
    width: '100%',
    padding: theme.spacing(2),
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 2, 0, 2),
  '& .MuiTypography-root': {
    fontWeight: 700,
    fontSize: '1.25rem',
  },
}));

export const CloseButton = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.grey[500],
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    color: theme.palette.grey[700],
  }
}));

export const SubTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.9rem',
  marginBottom: theme.spacing(3),
  paddingLeft: theme.spacing(2),
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  boxShadow: 'none',
  padding: theme.spacing(0, 2),
  maxHeight: '400px', // Fixed height for scrolling
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[300],
    borderRadius: '4px',
  },
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& .MuiTableCell-root': {
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: '0.9rem',
    padding: theme.spacing(2, 1),
    backgroundColor: theme.palette.background.paper, // Needed for sticky header
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '& td': { borderBottom: 0 },
}));

export const DateCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  fontSize: '1rem',
  padding: theme.spacing(2, 1),
  '& span': {
    display: 'block',
    fontWeight: 400,
    fontSize: '0.85rem',
    color: theme.palette.text.secondary,
  }
}));

export const StatusCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(2, 1),
}));

export const AvailableStatus = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.text.primary,
  fontSize: '0.95rem',
  '& svg': {
    color: theme.palette.success.main, // Green color for check
    fontSize: '1.1rem',
  }
}));

export const UnavailableStatus = styled('div')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '1.2rem',
  fontWeight: 500,
  paddingLeft: theme.spacing(1),
}));
